import { z } from "zod"
import { infraredFlightOptions, orthoFlightOptions } from "./transferable"

export const transferSettings = z.object({
    enabled: z.boolean().default(false),
    path: z.string().default("{timestamp}/{...tags}/{project}"),
    options: z
        .object({
            infrared: infraredFlightOptions,
            ortho: orthoFlightOptions,
        })
        .optional(),
    integrationName: z.string(),
})

export type TransferSettings = z.infer<typeof transferSettings>
